import {runInContext as api} from "lodash";

export const taskSettingsApi = {
    getAllSettings: () => api.get('/api/v1/task-settings'),
    getSettingById: (id) => api.get(`/api/v1/task-settings/${id}`),
    createSetting: (data) => api.post('/api/v1/task-settings', data),
    updateSetting: (id, data) => api.put(`/api/v1/task-settings/${id}`, data),
    deleteSetting: (id) => api.delete(`/api/v1/task-settings/${id}`),
    toggleSettingStatus: (id) => api.patch(`/api/v1/task-settings/${id}/toggle-status`)
};
